// executivesData.js

const TeachingStaffData = [
  {
    id: 1,
    name: "Dr. Samuel Foli, PhD",
    position: "Economist",
    aboutPosition:
      "The President & Founder provides strategic direction, establishes partnerships, & represents the organization in fostering innovation & achieving its mission.",
    image: "/image-fix/teaching-staff/Dr-Samuel-Foli-PhD.jpg",
    resizedimage: "/image-fix/teaching-staff/Dr-Samuel-Foli-PhD.jpg",
    aboutExecutive:
      "Samuel Foli is an economist and early career academic focused on knowledge risk, the circular economy and SME performance. He holds a PhD in Business at Reykjavík University, where his thesis develops a methodological framework for assessing knowledge risks under Professor Susanne Durst. He works as an Economist with PKF Malta and lectures on strategy, governance and research methods at GBSB Global and the European College of Innovation. His research appears in Knowledge and Process Management, the Journal of Information and Knowledge Management, and Discover Sustainability, with additional articles under review. He reviews for IEEE Transactions on Engineering Management and leading Emerald journals, and has presented at IFKAD and TAKE conferences. His interests span knowledge management, risk, digital competence and inclusive, sustainable business models.",
    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },


  {
    id: 3,
    name: "Seth Marfo, MBA",
    position: "Experienced Lecturer",
    aboutPosition:
      "The Programmes Consultant designs & evaluates program frameworks, ensures alignment with objectives, & drives impactful solutions for stakeholders.",
    image: "/image-fix/teaching-staff/Seth-Marfo-MBA.jpg",
    resizedimage: "/image-fix/teaching-staff/Seth-Marfo-MBA.jpg",
    aboutExecutive:
      "Experienced lecturer and training facilitator with 7+ years across undergraduate and executive education. Designs and delivers HRM, organisational behaviour and strategic leadership modules, online and in person. Currently delivers executive programmes with Globara UK, aligning content to learning outcomes and CPD standards. Previously lectured at BT Institute of Science and Technology in Ghana, leading syllabus design, assessment setting and moderation, and supervising 40+ research projects. Combines academic expertise with operations experience from a UK management role, bringing applied, people centred insights to teaching. Confident with LearnDash, Moodle and Zoom, and experienced in quality assurance, programme review and learner support. Holds an MBA in Human Resource Management from Cardiff Metropolitan University and a BA in Political Science with Linguistics from the University of Ghana, plus CIPD Level 7 and ongoing CPD in digital learning and inclusive teaching.",
    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },

  {
    id: 4,
    name: "Stephen Fenech MBA (Henley)",
    position: "MSc Sustainable Energy (Melit)",
    aboutPosition:
      "The Programmes Consultant designs & evaluates program frameworks, ensures alignment with objectives, & drives impactful solutions for stakeholders.",
    image: "/image-fix/teaching-staff/Stephen-Fenech-MBA-(Henley).jpg",
    resizedimage: "/image-fix/teaching-staff/Stephen-Fenech-MBA-(Henley).jpg",
    aboutExecutive:
      "Stephen Fenech is a Maltese business leader, lecturer and renewable energy consultant with deep experience across finance, operations and HR. He is Managing Director of Natural Power Limited and previously served as HR and Administration Director at the Malta Council for Science and Technology, Esplora. Since 2015 he has advised organisations on strategy, feasibility, funding and project delivery in solar and wider sustainability. Stephen lectures MBA-level finance, leadership and strategy with Malta Leadership Institute and London School of Commerce Malta, and supports dissertation supervision and academic integrity. Earlier he led Bajada Group, delivering Malta’s largest roof mounted photovoltaic plant at 850 kWp, after senior finance roles in tourism, construction and manufacturing. He holds an MSc in Sustainable Energy, an MBA from Henley, and certifications in ISO 9001 internal auditing and CE marking.",
    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },

  {
    id: 5,
    name: "Prof Dr Indra Devi Rajamanoharan ",
    position: "Acting Chair, Academic Board/Senior Lecturer",
    aboutPosition:
      "Oversees academic governance, quality assurance and accreditation; mentors faculty and drives student-success initiatives.",
    image: "/image-fix/executive-team-images/Dr_Indra_Devi_Rajamanoharan.jpg",
    resizedimage:
      "/image-fix/executive-team-images/Dr_Indra_Devi_Rajamanoharan.jpg",
    aboutExecutive:
      "Prof. Dr. Indra Devi Rajamanoharan is an academic leader and educator with experience in programme design, quality assurance, and stakeholder engagement. As Acting Chair of the Academic Board, she leads curriculum review cycles, strengthens assessment and external moderation processes, and ensures alignment with institutional and regulatory standards. As a Senior Lecturer, she focuses on practice-oriented, inclusive teaching and supervision, fostering graduate employability and industry relevance. She has collaborated across departments to implement data-informed improvements in learning and teaching, and continues to advocate for high academic standards and student success.",
    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },
];

export default TeachingStaffData;
